import { render, staticRenderFns } from "./peopleGL.vue?vue&type=template&id=2895cd1d&scoped=true"
import script from "./peopleGL.vue?vue&type=script&lang=js"
export * from "./peopleGL.vue?vue&type=script&lang=js"
import style0 from "./peopleGL.vue?vue&type=style&index=0&id=2895cd1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895cd1d",
  null
  
)

export default component.exports